// extracted by mini-css-extract-plugin
export var container = "paymentsRateSection-module--container--e57c4";
export var description = "paymentsRateSection-module--description--c0e92";
export var heading = "paymentsRateSection-module--heading--fc7f3";
export var info = "paymentsRateSection-module--info--d4737";
export var infoSection = "paymentsRateSection-module--infoSection--7e4f9";
export var label = "paymentsRateSection-module--label--a4b36";
export var listItem = "paymentsRateSection-module--listItem--50dd5";
export var rate = "paymentsRateSection-module--rate--ebe61";
export var rateCard = "paymentsRateSection-module--rateCard--3a854";
export var rateList = "paymentsRateSection-module--rateList--bd5ca";
export var rateSection = "paymentsRateSection-module--rateSection--ef0db";
export var title = "paymentsRateSection-module--title--dbbf5";